<template>
  <!--头部导航栏-->
  <div class="header-bar-en">
    <a-menu mode="horizontal">
      <a-menu-item style="line-height:10vh;width: 145px;padding: 0">
        <router-link @click.passive="backtotop" :to="'/index'">
          <img src="../../assets/logo.svg" style="width: 145px;height: 40px">
        </router-link>
      </a-menu-item>
      <a-menu-item v-for="(item, index) in routers" :key="index" class="item_en" :id="index">
        <router-link :to="item.url" @click.passive="backtotop">{{ item.title }}</router-link>
      </a-menu-item>

      <a-menu-item style="line-height:10vh;width: 2vw;padding: 0">
        <img src="../../assets/cn.png" style="height: 25px;width: 25px;margin-bottom: 10px" @click.passive="to">
      </a-menu-item>
      <a-menu-item style="width: 2vw;line-height: 10vh;padding: 0 0.3vw 0 0.5vw">
        <router-link :to="'/index_en'">
          <HomeOutlined :style="{fontSize: '22px', margin: '0',}"/>
        </router-link>
      </a-menu-item>

       <a-menu-item style="line-height:10vh;width: 2vw;padding: 0">
        <router-link :to="'/search_en'">
          <SearchOutlined :style="{fontSize: '22px', margin: '0',}"/>
        </router-link>
      </a-menu-item>
    </a-menu>
  </div>
</template>

<script>
import {reactive, onMounted} from 'vue'
import {SearchOutlined, HomeOutlined} from '@ant-design/icons-vue'

export default {
  name: 'Header_en',
  components: {
    SearchOutlined,
    HomeOutlined,
    onMounted,
  },
  setup() {
    const routers = reactive([  //路由对应
      {url: '/index_en', title: 'Home'},
      {url: '/concept_en', title: 'Value'},
      {url: '/team_en', title: 'Team'},
      {url: '/enterprise_en', title: 'Portfolio'},
      {url: '/news_en', title: 'News'},
      {url: '/contact_en', title: 'Contact Us'},
    ])
    const backtotop = () => {  //回到头部位置
      document.documentElement.scrollTo(0, 0)
    }
    const to = () => {
      let thisPage = window.location.href.toString();
      if (thisPage.search('/index') !== -1) {
        thisPage = thisPage.replace('index_en', 'index')
      } else if (thisPage.search('/concept') !== -1) {
        thisPage = thisPage.toString().replace('concept_en', 'concept')
      } else if (thisPage.search('/team') !== -1) {
        thisPage = thisPage.toString().replace('team_en', 'team')
      } else if (thisPage.search('/enterprise') !== -1) {
        thisPage = thisPage.toString().replace('enterprise_en', 'enterprise')
      } else if (thisPage.search('/news') !== -1) {
        thisPage = thisPage.toString().replace('news_en', 'news')
      } else if (thisPage.search('/contact') !== -1) {
        thisPage = thisPage.toString().replace('contact_en', 'contact')
      }else if (thisPage.search('/search') !== -1){
        thisPage = thisPage.toString().replace('search_en', 'search')
      }
      window.location.href = thisPage
    }
    return {routers, backtotop, to}
  }
}
</script>

<style>
.item_en {
  width: 11vw;
  line-height: 10vh;
}

.header-bar-en {
  list-style-type: none;
  margin: 0;
  padding: 0;
  overflow: hidden;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 999;
}

</style>
